// Details for Storefront API.
const storefrontAccessToken = {
  dev: '',
  prod_au: '56e6ad679ea6b474741fcf76b529daf5',
  prod_intl: '5e43b401de7900677dab829592017deb',
  prod_uk: '04ac64cd7dd3102b28a5197c012f7562',
  prod_us: '306e16540eb8a824c498a2f5e7b5f1d9'
}

const storeURL = {
  dev: 'le-specs-development.myshopify.com',
  prod_au: 'lespecs.myshopify.com',
  prod_intl: 'lespecseu.myshopify.com',
  prod_uk: 'lespecsuk.myshopify.com',
  prod_us: 'lespecsus.myshopify.com'
}

function getAccessToken () {
  // eslint-disable-next-line no-undef
  switch (Shopify.shop) {
    case storeURL.dev:
      return storefrontAccessToken.dev
    case storeURL.prod_au:
      return storefrontAccessToken.prod_au
    case storeURL.prod_intl:
      return storefrontAccessToken.prod_intl
    case storeURL.prod_uk:
      return storefrontAccessToken.prod_uk
    case storeURL.prod_us:
      return storefrontAccessToken.prod_us
    default:
      return storefrontAccessToken.prod_uk
  }
}

export const storefrontRequestConfig = {
  headers: {
    'Content-Type': 'application/json',
    'X-Shopify-Storefront-Access-Token': getAccessToken()
  }
}

// XHR request header is required to catch certain errors e.g. adding over quantity available
// https://community.shopify.com/c/Shopify-Design/AJAX-POST-cart-add-js-NEVER-returns-422-only-200-OK-on/m-p/375736
// https://stackoverflow.com/questions/17478731/whats-the-point-of-the-x-requested-with-header
export const xhrRequestConfig = {
  headers: {
    'X-Requested-With': 'XMLHttpRequest'
  }
}
